import React, { useState } from "react";
import '../styles/teacher.css';
import wellImage from "../assets/images/teachers/well.png";
import alvaroImage from "../assets/images/teachers/alvaro.jpg";
import ismaelImage from "../assets/images/teachers/ismael.jpg";

const teachers = [
  { 
    name: "WELLINGTON DESBALMES", 
    details: [
      "Sócio e Proprietário da Empresa RW Performance",
      "Técnico em Administração de Empresas com Ênfase em Contabilidade.",
      "Licenciado e Bacharel em Educação Física.",
      "Especialista em Lesões e Doenças Musculoesquéleticas e Condicionamento Físico.",
      "Fisioterapeuta",
      "Pós Graduando em Fisioterapia traumato-Ortopédica",
      "Pós Graduando em Fisioterapia Dermatofuncional com Injetáveis",
      "Línguas Estrangeiras: Inglês.",
      "Atuando há 12 anos na área de fitnes ministrando aulas de Natação, Musculação, Ginástica.Treinamento de profissionais da área e gerenciamento de academias.",
      "Professor Palestrante em Universidades e Curso Técnicos.",
      "Diversos cursos da área fitness e gerenciamento de pessoas e atendimento musculoesquelética."
    ],
    img: wellImage
  },
  { 
    name: "ÁLVARO RAFAEL PAULINO", 
    details: [
      "Sócio e Proprietário da Empresa RW Performance",
      "Técnico em Administração de Empresas e Recursos Humanos.",
      "Bacharel em Administração.",
      "Visual Merchandising.",
      "Diversos cursos na área de empreendedorismo, vendas, marketing, estratégias de negocios, gestão de tempo entre outros.",
      "Experiência de 11 anos no Mercado varejista com gerenciamento de Pessoas e equipes de Vendas.",
    ],
    img: alvaroImage
  },
  { 
    name: "ISMAEL FREITAS", 
    details: [
      "Sócio-proprietário da empresa RW Performance.",
      "Bacharel em Educação Física",
      "Fisioterapeuta",
      "Especialista em Ciências da Saúde no Exercício e no Esporte.",
      "Pós graduando em fisioterapia ortopédica e esportiva",
      "Pós graduando em fisiologia e fisiopatologia",
      "Mais de 10 anos atuando no mundo fitnes ministrando diversas aulas de Natação, musculação, Pilates entre outros.",
      "Diversos cursos na área envolvendo atendimento ao público e aprimoramento da parte técnica como Reabilitação Funcional HIIT entre outros."
    ],
    img: ismaelImage
  },
];

const TeachersSection = () => {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  return (
    <section id="founders">
    <div className="teachers-section">
      <h2 className="section-title">Nossos Fundadores</h2>
      <div className="teachers-container">
        {teachers.map((teacher, index) => (
          <div 
            key={index} 
            className="teacher-card"
            onMouseEnter={() => setHoveredIndex(index)}
            onMouseLeave={() => setHoveredIndex(null)}
          >
            <img src={teacher.img} alt={teacher.name} className="teacher-img" />
            {hoveredIndex === index && (
              <div className="teacher-info">
                <h3 className="teacher-name">{teacher.name}</h3>
                <ul className="teacher-description">
                  {teacher.details.map((detail, i) => (
                    <li key={i}>{detail}</li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        ))}
      </div>
      <br></br>
      <br></br>
    </div>
    </section>
  );
};

export default TeachersSection;
